export default __webpack_public_path__ + "static/media/ic_table_settings_24px.900d756a.svg";